import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface PaginationProps {
  page: number;          // 1-based
  pageCount: number;
  onChange: (page: number) => void;
  total?: number;
  className?: string;
}

/** Previous / "page X of Y" / next (DESIGN_SYSTEM.md §7). Chevrons follow reading direction. */
export default function Pagination({ page, pageCount, onChange, total, className = '' }: PaginationProps) {
  const { t } = useTranslation();
  if (pageCount <= 1) return null;
  return (
    <nav className={`flex items-center justify-between gap-3 text-sm text-surface-600 ${className}`} aria-label={t('common.pagination')}>
      <span className="tabular-nums">
        {typeof total === 'number' ? t('common.pageOfTotal', { page, pages: pageCount, total }) : `${page} / ${pageCount}`}
      </span>
      <div className="flex items-center gap-1">
        <button type="button" className="btn btn-secondary btn-sm" onClick={() => onChange(page - 1)} disabled={page <= 1} aria-label={t('common.previous')}>
          <ChevronRight size={16} className="ltr:rotate-180" />
          <span className="hidden sm:inline">{t('common.previous')}</span>
        </button>
        <button type="button" className="btn btn-secondary btn-sm" onClick={() => onChange(page + 1)} disabled={page >= pageCount} aria-label={t('common.next')}>
          <span className="hidden sm:inline">{t('common.next')}</span>
          <ChevronLeft size={16} className="ltr:rotate-180" />
        </button>
      </div>
    </nav>
  );
}
